module.exports = __webpack_public_path__ + "img/event_4.790541ff.jpg";